<template>
  <div class="organization-payment-methods">
    <v-tabs v-if="false">
      <v-tab :to="{ name: 'organizations.payment-methods' }" exact>{{ $t('payment.tabs.payments') }}</v-tab>
      <v-tab :to="{ name: 'organizations.payout'}" exact>{{ $t('payment.tabs.payouts') }}</v-tab>
    </v-tabs>
    <router-view></router-view>
    <div></div>
  </div>
</template>

<script>
export default {

  data() {
    return {}
  },

  computed: {
    organization() {
      return this.$parent && this.$parent.organization ? this.$parent.organization : null
    }
  }
}
</script>

<style lang="scss">
.organization-payment-methods {}
</style>
